import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=4a8be8ce&scoped=true&"
import script from "./IconBadge.vue?vue&type=script&lang=js&"
export * from "./IconBadge.vue?vue&type=script&lang=js&"
import style0 from "./IconBadge.vue?vue&type=style&index=0&id=4a8be8ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8be8ce",
  null
  
)

export default component.exports